// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const CurveSmoothIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="CurveSmoothIcon" ref={forwardedRef} {...props}>
      <path d="M16.235 14a8 8 0 0 0 .015-.484c0-3.842-2.9-6.766-6.25-6.766s-6.25 2.924-6.25 6.766A8 8 0 0 0 3.766 14H2.013A9 9 0 0 1 2 13.516C2 8.813 5.582 5 10 5s8 3.813 8 8.516A9 9 0 0 1 17.987 14z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const CurveSmoothIcon = /* @__PURE__ */ Object.assign(
  CurveSmoothIconComponent,
  { displayName: 'CurveSmoothIcon' },
);
